import services from './../../services/service'; // Service Class
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer

let service = new services();

export default {
    name: 'CNwallet',
    data () {
        return {
            user: {},
            referrals:{},
            referral_code:"",
            loading:true,
            disable_btn:false,
            site_url: "",
            referral_text: "",
            copy_succ:false,
            site_set_url: "https://share.cityneeds.ng/?ref=",
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter
    },
    methods: {
        //settings
        copyLink() {
            document.getElementById("copiied").style.color = "#ffff00";
            this.copy_succ =  true;
            this.$clipboard(this.referral_text)
            // var btn = $('.linky').tooltip({
            //     trigger: 'click',
            //     placement: 'bottom'
            // });
            // this.setTooltip(btn, 'Copied');
            // this.hideTooltip(btn);
            // this.copy_succ =  true;
        },
        fbShare(url, title, descr, image, winWidth, winHeight) {
            var winTop = (screen.height / 2) - (winHeight / 2);
            var winLeft = (screen.width / 2) - (winWidth / 2);
            window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
        },
        setPanel() {
            this.panelFlag = true
        },
        
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.user = data.body.data;
                                    this.referral_code = this.user.user_referral_code;
                                    this.site_url = this.site_set_url+this.referral_code;
                                    this.getReferralTransactions();
                                 }
                            }).catch((err) => {
                                if(err) {
                                   //log me
                                }
                            })
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        getReferralTransactions() {
            let user_id = localStorage.getItem("cityneeds_token_key");
            service.getReferralTransactions(this,user_id).then(data => {
                 this.referrals = data.body.data;
               //  this.referral_code = data.body.data_referral_code;
                 this.site_url = this.site_set_url+this.referral_code;
                 this.referral_text = 
                 `Hi Dear,\nCityneeds is a convenient and easy-to-use platform where i find skillful and vetted artisans, get contact information of businesses, pay my utility bills, and buy airtime, all from the comfort of my phone, or tablet. Just so you know, I get cashback rewards for most payments I make.
                 \nYou too can start using it now! Click to signup for free: `+this.site_set_url+this.referral_code;
                 this.loading = false;
             }).catch((err) => {
                 if(err) {
                     toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
         },


 
        
    },
    created: function(){
        this.preset();
        // this.getReferralTransactions();
    }
}


// WEBPACK FOOTER //
// ./src/components/MyReferrals/script.js